import './MockLogin.scss';
import {
  Typography,
  Button,
  TextFieldInput,
} from 'br2s-ui-componentlibrary_r2_02';
import OfficePeople from '@/assets/office-people.png';
import GlassCard from '@/components/GlassCard/GlassCard';
import { LOGIN_PAGE } from '@/utilities/constants';
import { ChangeEvent, useState } from 'react';
import * as localService from '@/services/localService/localService';
import { HTTPErrorAlertContainer } from 'br2s-ui-common-utils-02';

const MockLogin = () => {
  const OFFICE_PEOPLE_IMG_HEIGHT = 696;
  const [userName, setUserName] = useState('');
  const [pd, SetPassword] = useState('');

  const changeUserName = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setUserName(value);
  };

  const changePassword = (e: ChangeEvent<HTMLInputElement>) => {
    SetPassword(e.target.value);
  };

  // istanbul ignore next
  const login = () => {
    if (
      userName === `${process.env.REACT_APP_MOCK_LOGIN_USERNAME}` &&
      pd === `${process.env.REACT_APP_MOCK_LOGIN_PASSWORD}`
    ) {
      localService.setMockLoginAuth('true');
      window.location.href = `${process.env.REACT_APP_BROWSER_ROUTER_BASENAME}/home`;
    }
  };

  return (
    <div className="login">
      <HTTPErrorAlertContainer className="error-container" />
      <div className="header-login">
        <div>
          <Typography
            type="headline-1"
            weight="bold"
            label={LOGIN_PAGE.HEADING_1}
          />
        </div>
        <div className="office-people-container">
          <img
            src={OfficePeople}
            height={OFFICE_PEOPLE_IMG_HEIGHT}
            alt="office-people"
          />
        </div>
      </div>
      <GlassCard>
        <div className="cards-container">
          <div className="fields">
            <TextFieldInput
              id="cmp-username"
              name="username-input"
              value={userName}
              placeholder="Username"
              onChange={(e) => changeUserName(e)}
            />
            <input
              className="form-input"
              id="cmp_passowrd"
              value={pd}
              type="password"
              onChange={(e) => changePassword(e)}
              placeholder="Password"
            ></input>
            <Button
              id="login-button"
              onClick={login}
              label="Login"
              isDisabled={userName.length === 0 && pd.length === 0}
            />
          </div>
        </div>
      </GlassCard>
    </div>
  );
};

export default MockLogin;
